var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 93,
    viewBox: "0 0 312 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1 80H149.431H185.653C188.182 80 190.674 79.4008 192.926 78.2516L218.407 65.2484C220.659 64.0992 223.152 63.5 225.68 63.5H249.715C252.628 63.5 255.485 62.7052 257.978 61.2012L286.5 44",
    stroke: "#DEC991",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 80H149.431H185.653C188.182 80 190.674 79.4008 192.926 78.2516L218.407 65.2484C220.659 64.0992 223.152 63.5 225.68 63.5H249.715C252.628 63.5 255.485 62.7052 257.978 61.2012L286.5 44",
    stroke: "#DEC991",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8807_31167)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 38,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.5,
    y: 36.5,
    width: 17,
    height: 17,
    rx: 8.5,
    stroke: "#F6F6F6",
    strokeOpacity: 0.16,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 45,
    r: 4,
    fill: "#DEB955"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8807_31167",
    x: 239,
    y: 0.5,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.72549 0 0 0 0 0.333333 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8807_31167"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8807_31167",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.118e3faaa7eec3adb887354e3b26e056.svg";
export { ForwardRef as ReactComponent };